import { createAction, props } from '@ngrx/store';
import { AllocationStatusDTO } from '@core/services/allocation/allocation.service';

export const PROJECT_DETAILS = {
	PROJECT: {
		GET: createAction('[Project details] Get project', props<any>()),
		SUCCESS: createAction('[Project details] Get project success', props<any>()),
		FAILURE: createAction(
			'[Project details] Get project failure',
			props<{ payload: { message: string } }>()
		),
		SET_ID: createAction('[Project details] Set project id', props<{ projectId: any }>()),
		BEST_RATE: createAction('[Project details] Set project id', props<{ projectId: any }>()),
		SET_CAPACITY_SEARCH_FORM: createAction(
			'[Project details] Set capacity search form',
			props<any>()
		),

		GET_ALL: createAction('[Project details] Get all projects', props<any>()),
		GET_ALL_SUCCESS: createAction('[Project details] Get all projects success', props<any>()),
		GET_ALL_FAILURE: createAction(
			'[Project details] Get all projects failure',
			props<{ payload: { message: string } }>()
		),
		SET_ALL_PROJECTS_LIST: createAction('[Project details] Set all projects list', props<any>()),
		SET_PROJECTS_NEXT_PAGE: createAction(
			'[Project details] Set all projects next page',
			props<any>()
		),
		SET_PROJECTS_PAGE: createAction('[Project details] Set all projects page', props<any>()),
		SET_TOTAL_PROJECTS: createAction('[Project details] Set total projects count', props<any>()),
		SET_CARRIERS_PROJECTS_LIST: createAction(
			'[Project details] Set carriers projects list',
			props<any>()
		),
	},
	PROCURED_CARRIERS: {
		RELOAD: createAction('[Project details] Reload procured carriers view', props<any>()),
	},

	PAGING: {
		PAGE_NUMBER: createAction(
			'[Project details] Set in progress carriers page number',
			props<{ pageNumber: any }>()
		),
		PAGE_SIZE: createAction(
			'[Project details] Set in progress carriers page size',
			props<{ pageSize: any }>()
		),
	},
	ENGAGED_CARRIER_IDS: {
		SET: createAction(
			'[Project details] Set engaged carrier ids',
			props<{ carrierIds: string[] }>()
		),
	},
	RECOMMENDED_CARRIERS: {
		RELOAD_SEARCH: createAction('[Project details] Reload recommended carriers view', props<any>()),
		SEARCH_LANES: createAction('[Project details] Search lanes capacity search', props<any>()),
	},
	RESET_STATE: createAction('[Project details] Reset page state', props<any>()),

	SET: {
		USERS_LIST: createAction('[Project details] Set active users list', props<any>()),
		CUSTOMER_ONLY_PROJECT: createAction(
			'[Project details] Set if project is for customer only',
			props<any>()
		),
	},

	BA: {
		OPEN_DIALOG: createAction('[Project details] open BA form dialog', props<any>()),
		CLOSE_DIALOG: createAction('[Project details] close BA form dialog', props<any>()),
	},

	DOWNLOAD: {
		PROCURED_CARRIERS: createAction(
			'[Project details] Download procured carriers csv file',
			props<any>()
		),
		ENGAGEED_CARRIERS: createAction(
			'[Project details] Download engaged carriers csv file',
			props<any>()
		),
		ALLOCATED_CARRIERS: createAction(
			'[Project details] Download allocated carriers csv file',
			props<any>()
		),
		SUCCCESS: createAction('[Project details] Project carriers csv file downloaded', props<any>()),
	},

	NOTIFICATION_UPDATES: {
		BEST_RATE: createAction('[Project details] update project best rate', props<any>()),
		PROBABILITY: createAction('[Project details] update project probability', props<any>()),
	},

	ALLOCATIONS: {
		LOAD: createAction('[Project details] Load carrier allocations', props<{ projectId: string }>()),
		LOAD_SUCCESS: createAction(
			'[Project details] Load carrier allocations success',
			props<{ allocations: AllocationStatusDTO[] }>()
		),
		LOAD_FAILURE: createAction(
			'[Project details] Load carrier allocations failure',
			props<{ error: string }>()
		),
		DELETE: createAction(
			'[Project details] Delete carrier allocation',
			props<{ allocationId: string; projectId: string }>()
		),
		DELETE_SUCCESS: createAction(
			'[Project details] Delete carrier allocation success',
			props<{ allocationId: string; projectId: string }>()
		),
		DELETE_FAILURE: createAction(
			'[Project details] Delete carrier allocation failure',
			props<{ error: string }>()
		),
	},
};
